import { createContext, type FC, type ReactNode } from "react";

export type BreadcrumbItem = {
    label: ReactNode;
    to?: string;
    /**
     * Secondary muted text to display after the label
     */
    description?: string;
    /**
     * Optional icon to display before the label
     */
    icon?: FC<{ className?: string }>;
};

export const SettingsPageContext = createContext<{
    setBreadCrumbRowAction: (action: ReactNode) => void;
    setCustomBreadcrumbs: (items: BreadcrumbItem[] | null) => void;
}>({
    setBreadCrumbRowAction: () => {
        // just an empty setter by default, but ESLint wants some content anyway
    },
    setCustomBreadcrumbs: () => {
        // just an empty setter by default, but ESLint wants some content anyway
    },
});
